import { render, staticRenderFns } from "./PurchaseStatementComponent.vue?vue&type=template&id=5c9330f3&scoped=true"
import script from "./PurchaseStatementComponent.vue?vue&type=script&lang=js"
export * from "./PurchaseStatementComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9330f3",
  null
  
)

export default component.exports